import React, { useEffect, useRef } from "react"

import { WebSource } from "../../../../model/types"
import SourceHeader from "./source_view/source_header"
import SourceNotes from "./source_view/source_notes"

export default function SourceView({
  source,
  setOpenSource,
}: {
  source: WebSource
  setOpenSource: (source: WebSource | null) => void
}) {
  const prevent = (e: Event) => {
    e.preventDefault()
  }

  const noScrollRef = useRef<HTMLDivElement>(null)

  // No scrolling on the source view. This is normally not possible anyway because it's a fixed layout, but in mobile Safari when the keyboard is open everything goes nuts, and scrolling is very confusing.
  useEffect(() => {
    if (!noScrollRef.current) return
    noScrollRef.current.addEventListener("touchmove", prevent)
    return () => noScrollRef.current?.removeEventListener("touchmove", prevent)
  }, [noScrollRef.current])

  return (
    <>
      <div ref={noScrollRef}>
        <div className="mb-2">
          <SourceHeader source={source} setOpenSource={setOpenSource} />
        </div>
      </div>
      <SourceNotes source={source} />
    </>
  )
}
